<i18n>
{
    "ru": {
        "agree_to_terms_1": "Нажимая кнопку «Купить», я подтверждаю, что ознакомился и согласен с условиями",
        "agree_to_terms_2": "соглашения с покупателем билета",
        "agree_to_personal_data_processing_1": "Нажимая кнопку «Купить», я даю",
        "agree_to_personal_data_processing_2": "согласие",
        "agree_to_personal_data_processing_3": "на обработку моих персональных данных в соответствии с",
        "agree_to_personal_data_processing_4": "политикой конфиденциальности",
        "agree_to_receive_promotional_materials_1": "Нажимая кнопку «Купить», я даю",
        "agree_to_receive_promotional_materials_2": "согласие",
        "agree_to_receive_promotional_materials_3": "получение от организатора трансляции рекламных и информационных рассылок"
    },
    "en": {
        "agree_to_terms_1": "By clicking the \"Buy\" button, I confirm that I have read and agree to the terms of the",
        "agree_to_terms_2": "Ticket Purchaser Agreement",
        "agree_to_personal_data_processing_1": "By clicking the \"Buy\" button, I",
        "agree_to_personal_data_processing_2": "consent",
        "agree_to_personal_data_processing_3": "to the processing of my personal data in accordance with the",
        "agree_to_personal_data_processing_4": "Privacy Policy",
        "agree_to_receive_promotional_materials_1": "By clicking the \"Buy\" button, I",
        "agree_to_receive_promotional_materials_2": "consent",
        "agree_to_receive_promotional_materials_3": "to receiving promotional and informational newsletters from the broadcast organizer"
    }
}
</i18n>

<template>
    <form :class="$style.form" @submit.prevent="handleSubmit">
        <FormHeadline />

        <div :class="$style.form__content">
            <FormAdvice />

            <div :class="[$style.field, $style.name, (hasNameForComments && hasCommentsSelfnaming && hasChat) ? $style.name_before_checkbox : '']">
                <label for="name">{{ $t("forms.ticket.labels.name") }}</label>
                <input id="name" v-model.trim="name" type="text" :placeholder="$t('forms.ticket.placeholders.name')" />
                <WarningInputMessage :title="(errors && errors.name) ? errors.name : ''" v-show="!hasNameForComments || !hasChat || !hasCommentsSelfnaming ||  (errors && errors.name)"/>
            </div>

            <div :class="[$style.field, $style.use_name_in_chat_checkbox]" v-show="(hasNameForComments && hasCommentsSelfnaming && hasChat)">
                <input id="use_name_in_chat" type="checkbox" v-model="useNameInChat">
                <label for="use_name_in_chat">{{ $t("forms.ticket.labels.use_name_in_chat") }}</label>
            </div>

            <div :class="[$style.field, $style.name]" v-show="!useNameInChat">
                <label for="name_for_chat">{{ $t("forms.ticket.labels.name_for_chat") }}</label>
                <input id="name_for_chat" v-model.trim="nameForChat" type="text" :placeholder="$t('forms.ticket.placeholders.name')" maxlength="64"/>
                <WarningInputMessage :title="(errors && errors.name_for_chat) ? errors.name_for_chat : ''" />
            </div>

            <div :class="[$style.field, $style.email]">
                <label for="email">{{ $t("forms.ticket.labels.email") }}</label>
                <input
                    id="email"
                    v-model.trim="email"
                    type="text"
                    placeholder="mail@example.com"
                    v-on:keydown="validateEmailInput"
                    v-on:keyup="validateEmailInput"
                    v-on:keypress="validateEmailInput"
                />
                <WarningInputMessage :title="(errors && errors.email) ? errors.email : ''" />
            </div>

            <div :class="[$style.field, $style.phone]">
                <label for="phone">{{ $t("forms.ticket.labels.phone") }}</label>
                <div :class="$style.phoneInput">
                    <input
                        id="phone"
                        v-model.trim="phone"
                        type="tel"
                        :placeholder="$t('forms.ticket.placeholders.phone')"
                        v-on:input="validatePhoneInput"
                    />
                </div>
                <WarningInputMessage :title="(errors && errors.phone) ? errors.phone : ''" />
            </div>

            <div :class="$style.collapse">
                <button :class="$style.collapseTarget" type="button" @click.prevent="isOpened = !isOpened">
                    {{ $t("forms.ticket.labels.have_promo_code") }}?
                </button>

                <div v-show="isOpened" :class="$style.field">
                    <input id="code" v-model.trim="code" type="text" :placeholder="$t('forms.ticket.placeholders.code')" />
                    <span :class="$style.error">{{ (errors && errors.code) ? errors.code : "" }}</span>
                </div>
            </div>

            <div :class="[$style.select, (settings.allowedPaymentMethodsCnt == 1 ? $style.select_one : '')]">
                <PaymentMethodTitle />
                <div>
                    <div v-if="!+isHiddenPaymentMethod('sbpEnabled')" :style="{ order: settings.sortingPaymentMethods[0] }">
                        <label :class="payment === 'sbp' && $style.active">
                            <input v-model="payment" type="radio" value="sbp" name="sbp" tabindex="1" />
                            <!-- <h4>{{ $t("headlines.payment_credit_card_by_yandex") }}</h4> -->
                            <SbpPaymentBlockIcons />
                        </label>
                    </div>
                    <div v-if="!+isHiddenPaymentMethod('yandexKassaEnabled')" :style="{ order: settings.sortingPaymentMethods[0] }">
                        <label :class="payment === 'yookassa' && $style.active">
                            <input v-model="payment" type="radio" value="yookassa" name="yookassa" tabindex="1" />
                            <!-- <h4>{{ $t("headlines.payment_credit_card_by_yandex") }}</h4> -->
                            <YandexPaymentBlockIcons />
                        </label>
                    </div>
                    <div v-if="!+isHiddenPaymentMethod('cloudPaymentsEnabled')" :style="{ order: settings.sortingPaymentMethods[1] }">
                        <label :class="payment === 'cloudpayments' && $style.active">
                            <input v-model="payment" type="radio" value="cloudpayments" name="cloudpayments" tabindex="1" />
                            <!-- <h4>{{ $t("headlines.payment_credit_card_by_cloud_payments") }}</h4> -->
                            <CloudPaymentsBlockIcons />
                        </label>
                    </div>
                    <div v-if="!+isHiddenPaymentMethod('moscowCreditBankEnabled')" :style="{ order: settings.sortingPaymentMethods[2] }">
                        <label :class="payment === 'mkb' && $style.active">
                            <input v-model="payment" type="radio" value="mkb" name="mkb" tabindex="1" />
                            <!-- <h4>{{ $t("headlines.payment_credit_card_by_mkb") }}</h4> -->
                            <MoscowCreditBankBlockIcons />
                        </label>
                    </div>
                    <div v-if="!+isHiddenPaymentMethod('payPalEnabled')" :style="{ order: settings.sortingPaymentMethods[3] }">
                        <label :class="payment === 'paypal' && $style.active">
                            <input v-model="payment" type="radio" value="paypal" name="paypal" tabindex="1" />
                            <!-- <h4>PayPal</h4> -->
                            <div :class="$style.paypalIcons">
                                <PaypalPaymentBlockIcons />
                            </div>
                        </label>
                    </div>
                    <div v-if="!+isHiddenPaymentMethod('sberEnabled')" :style="{ order: settings.sortingPaymentMethods[4] }">
                        <label :class="payment === 'sber' && $style.active">
                            <input v-model="payment" type="radio" value="sber" name="sber" tabindex="1" />
                            <!-- <h4>{{ $t("headlines.payment_credit_card_by_sber") }}</h4> -->
                            <SberPaymentBlockIcons />
                        </label>
                    </div>
                    <div v-if="!+isHiddenPaymentMethod('prodamusEnabled')" v-show="foreignPaymantShow" :style="{ order: settings.sortingPaymentMethods[5] }">
                        <label :class="payment === 'prodamus' && $style.active">
                            <input v-model="payment" type="radio" value="prodamus" name="prodamus" tabindex="1" />
                            <!-- <h4>{{ $t("headlines.payment_credit_card_by_sber") }}</h4> -->
                            <ProdamusPaymentBlockIcons />
                        </label>
                    </div>
                </div>
            </div>

            <div :class="$style.agreement">
                <label for="agreement">
                    <input id="agreement" v-model="agreement" type="checkbox" />
                    <div v-bind:class="`${!agreement && showFillFieldsLabel ? $style.checkbox_error : ''}`">
                        <CheckIcon v-if="isAgreement" />
                    </div>
                    <span>
                        <span>{{ $t("agree_to_terms_1") }}</span>&nbsp;
                        <a target="_blank" v-bind:href="ticketLink">{{ $t("agree_to_terms_2") }}</a>
                    </span>
                </label>
            </div>

            <div :class="$style.agreement">
                <label for="agreementPd">
                    <input id="agreementPd" v-model="agreementPd" type="checkbox" />
                    <div v-bind:class="`${!agreementPd && showFillFieldsLabel ? $style.checkbox_error : ''}`">
                        <CheckIcon v-if="isAgreementPd" />
                    </div>
                    <span>
                        <span>{{ $t("agree_to_personal_data_processing_1") }}</span>&nbsp;
                        <a target="_blank" v-bind:href="privacyPdLink">{{ $t("agree_to_personal_data_processing_2") }}</a>&nbsp;
                        <span>{{ $t("agree_to_personal_data_processing_3") }}</span>&nbsp;
                        <a target="_blank" v-bind:href="privacyLink">{{ $t("agree_to_personal_data_processing_4") }}</a>
                    </span>
                </label>
            </div>

            <div :class="$style.agreement">
                <label for="agreementAds">
                    <input id="agreementAds" v-model="agreementAds" type="checkbox" />
                    <div>
                        <CheckIcon v-if="isAgreementAds" />
                    </div>
                    <span>
                        <span>{{ $t("agree_to_receive_promotional_materials_1") }}</span>&nbsp;
                        <a target="_blank" v-bind:href="adsLink">{{ $t("agree_to_receive_promotional_materials_2") }}</a>&nbsp;
                        <span>{{ $t("agree_to_receive_promotional_materials_3") }}</span>
                    </span>
                </label>
            </div>
            <PriceChangedHeadline v-if="isPriceChanged" />
            <BuyButton :loading="isLoadingBuyButton" :unagreement="!isAgreement" />
            <div :class="$style.fill_fields_label" v-if="this.showFillFieldsLabel">
                <span>{{ $t("forms.ticket.errors.fill_in_all_required_fields") }}</span>
            </div>
        </div>
        <div :class="$style.company_creds">
            <span v-if="!this.settings.agent_is_facecastpro">ООО «Фейскаст», ОГРН 1137746439885, ИНН 7723872870</span>
            <span v-if="this.settings.agent_is_facecastpro">ООО «Фейскаст.про», ОГРН 1157746980050, ИНН 7723414775</span>
        </div>
    </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { parsePhoneNumberFromString } from "libphonenumber-js";

import FormHeadline from "./FormHeadline";
import FormAdvice from "./FormAdvice";
import WarningInputMessage from "./WarningInputMessage";
import BuyButton from "./BuyButton";
import PriceChangedHeadline from "./PriceChangedHeadline";
import CheckIcon from "../shapes/Check";
import YandexPaymentBlockIcons from "./YandexPaymentBlockIcons";
import SbpPaymentBlockIcons from "./SbpPaymentBlockIcons";
import CloudPaymentsBlockIcons from "./CloudPaymentsBlockIcons";
import MoscowCreditBankBlockIcons from "./MoscowCreditBankBlockIcons";
import SberPaymentBlockIcons from "./SberPaymentBlockIcons";
import ProdamusPaymentBlockIcons from "./ProdamusPaymentBlockIcons";
import PaypalPaymentBlockIcons from "./PaypalPaymentBlockIcons";
import PaymentMethodTitle from "./PaymentMethodTitle";

export default {
    name: "Form",

    components: {
        FormHeadline,
        FormAdvice,
        WarningInputMessage,
        BuyButton,
        PriceChangedHeadline,
        CheckIcon,
        SbpPaymentBlockIcons,
        YandexPaymentBlockIcons,
        CloudPaymentsBlockIcons,
        MoscowCreditBankBlockIcons,
        PaypalPaymentBlockIcons,
        SberPaymentBlockIcons,
        SberPaymentBlockIcons,
        ProdamusPaymentBlockIcons,
        PaymentMethodTitle
    },

    props: ["type", "id"],

    data() {
        return {
            name: "",
            nameForChat: "",
            email: "",
            phone: "",
            lastValidPhone: "",
            code: "",
            payment: "1",
            agreement: false,
            agreementPd: false,
            agreementAds: false,
            showFillFieldsLabel: false,
            errors: undefined,

            priceChanged: false,

            isOpened: false,
            useNameInChat: true
        };
    },

    mounted() {
        this.autoInputFromQueryString();
        this.setDefaultPayment();
    },

    methods: {
        isHiddenPaymentMethod(method) {
            return !this.settings[method];
        },

        validatePhoneInput(e) {
            // Убираем любые символы кроме цифр и "+"
            this.phone = this.phone.replace(/[^\+\d]+/g, "");
            this.phone = (this.phone[0] || "") + this.phone.slice(1).replace(/[^\d]+/g, "");

            /**
             * Если первый символ не "+".
             * Если номер начинается с 8 заменяем на +7,
             * Иначе, если номер начинается с 9, добавляем в начале "+7"
             * Иначе, если номер начинается на 1,2,3,4,5,6,7 добавляем в начале "+"
             */
            if (/^8\d*$/.test(this.phone)) {
                this.phone = "+7" + this.phone.slice(1);
            } else if (/^9\d*$/.test(this.phone)) {
                this.phone = "+7" + this.phone;
            } else if (/^[1234567]\d*$/.test(this.phone)) {
                this.phone = "+" + this.phone;
            }

            if (this.phone.length && !/^\+(?![0])(\d{0,15})?$/.test(this.phone)) {
                this.phone = this.lastValidPhone;
            } else {
                this.lastValidPhone = this.phone;
            }
        },

        validateEmailInput(e) {
            if (e.code == "Space") {
                e.preventDefault();
            }
        },

        validatePhonePaste(e) {
            let data = null;
            try {
                data = e.clipboardData.getData("text/plain");

                if (!data.match(/^\d+$/gi)) {
                    e.preventDefault();
                }
            } catch (e) {
                e.preventDefault();
            }
        },

        async validate() {
            this.errors = undefined;
            this.showFillFieldsLabel = false

            const errors = {};

            if (this.name.length < 1) {
                errors.name = this.$t("forms.ticket.errors.required_field");
            }

            if (this.name.length > 256) {
                errors.name = this.$t("forms.ticket.errors.invalid_length_name");
            }

            if (this.hasNameForComments && this.hasCommentsSelfnaming && !this.useNameInChat && this.nameForChat.length < 1) {
                 errors.name_for_chat = this.$t("forms.ticket.errors.required_field");
            }

            if (this.hasNameForComments && this.hasCommentsSelfnaming && !this.useNameInChat && this.nameForChat.length > 64) {
                 errors.name_for_chat = this.$t("forms.ticket.errors.invalid_length_name");
            }

            if (
                !this.email.match(/^[a-zA-Z0-9]+(([+._-]+[a-zA-Z0-9_]+)+|([a-zA-Z0-9_]?))@[a-zA-Z0-9]+(([._-]+[a-zA-Z0-9]+)+|([a-zA-Z0-9]?))\.[a-zA-Z]{2,11}$/gi)
            ) {
                errors.email = this.$t("forms.ticket.errors.invalid_format_email");
            }

            if (this.email.length < 1) {
                errors.email = this.$t("forms.ticket.errors.required_field");
            }

            if (this.email.length > 256) {
                errors.email = this.$t("forms.ticket.errors.invalid_length_email");
            }

            let phoneNumber = parsePhoneNumberFromString(this.phone, "RU");

            if (!phoneNumber || !phoneNumber.isValid()) {
                errors.phone = this.$t("forms.ticket.errors.invalid_format_phone");
            }

            /**
             * Минимальное количество цифр в номере 10 + символ "+"
             * Максимальное количество цифр в номере 15 + символ "+"
             */
            if (this.phone.length < 11 || this.phone.length > 16) {
                errors.phone = this.$t("forms.ticket.errors.invalid_length_phone");
            }

            if (!this.phone.match(/^\+\d+$/gi)) {
                errors.phone = this.$t("forms.ticket.errors.invalid_characters_phone");
            }

            if (this.agreement !== true) {
                errors.agreement = true;
            }

            if (this.agreementPd !== true) {
                errors.agreementPd = true;
            }

            this.errors = errors;

            if (Object.keys(this.errors).length !== 0) {
                this.showFillFieldsLabel = true
                throw new Error("");
            }

            this.errors = undefined;

            this.phone = String(phoneNumber.countryCallingCode) + String(phoneNumber.nationalNumber);

            const r = await fetch("/api/" + this.$props.type + "/" + this.$props.id + "/ticket_price_online");
            const payload = await r.json();

            if (this.hasNameForComments && this.hasCommentsSelfnaming && this.useNameInChat) {
                this.nameForChat = this.name;
            }

            if (!this.hasCommentsSelfnaming) {
                this.nameForChat = this.name;
                this.useNameInChat = true;
            }

            if (+this.$store.state.data.data.ticket_price_online !== +payload.value) {
                this.$store.commit("data/SET_PRICE", payload.value);
                this.priceChanged = true;
                this.$store.commit("data/SET_LAST_DATA_FORM", {
                    name: this.name,
                    name_for_chat: this.nameForChat,
                    use_name_in_chat: this.useNameInChat,
                    email: this.email,
                    phone: this.phone,
                    code: this.code,
                    payment: this.payment,
                });

                throw new Error("");
            }

            if (+this.$store.state.data.data.ticket_price_online_foreign !== +payload.value_foreign) {
                this.$store.commit("data/SET_PRICE_FOREIGN", payload.value_foreign);
                this.priceChanged = true;
                this.$store.commit("data/SET_LAST_DATA_FORM", {
                    name: this.name,
                    name_for_chat: this.nameForChat,
                    use_name_in_chat: this.useNameInChat,
                    email: this.email,
                    phone: this.phone,
                    code: this.code,
                    payment: this.payment,
                });

                throw new Error("");
            }

            if (this.code) {
                const response = await fetch("/api/" + this.$props.type + "/" + this.$props.id + "/promocodes/" + this.code);

                if (response.status === 404) {
                    this.errors = { code: this.$t("forms.ticket.errors.invalid_promocode") };

                    throw new Error("");
                }
            }
        },
        handleSubmit() {
            const { type, id, name, email, phone, code, payment, nameForChat, useNameInChat } = this;

            this.validate()
                .then(() => this.submitData({ type, id, data: { name, email, phone: phone, code, payment, nameForChat, useNameInChat } }))
                .catch(() => {});
        },
        ...mapActions("form", ["submitData"]),

        autoInputFromQueryString() {
            if (this.getParameterByName("phone")) {
                const phone = this.getParameterByName("phone");

                if (phone.length < 10 || phone.length > 15) {
                    return;
                }

                if (!phone.match(/^\d+$/gi)) {
                    return;
                }

                this.phone = this.getParameterByName("phone");
            }

            if (this.getParameterByName("email")) {
                const email = this.getParameterByName("email");

                if (
                    !email.match(/^[a-zA-Z0-9]+(([+._-]+[a-zA-Z0-9_]+)+|([a-zA-Z0-9_]?))@[a-zA-Z0-9]+(([._-]+[a-zA-Z0-9]+)+|([a-zA-Z0-9]?))\.[a-zA-Z]{2,11}$/gi)
                ) {
                    return;
                }

                if (email.length < 1) {
                    return;
                }

                if (email.length > 256) {
                    return;
                }

                this.email = this.getParameterByName("email");
            }

            if (this.getParameterByName("name")) {
                const name = this.getParameterByName("name");

                if (name.length < 1) {
                    return;
                }

                if (name.length > 256) {
                    return;
                }

                this.name = this.getParameterByName("name");
            }
        },

        getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return "";
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        },

        setDefaultPayment() {
            const pMethods = {
                1: 'sbpEnabled',
                2: 'yandexKassaEnabled',
                3: 'payPalEnabled',
                4: 'cloudPaymentsEnabled',
                5: 'moscowCreditBankEnabled',
                6: 'sberEnabled',
                7: "prodamusEnabled",
            };

            let methods = {
                1: 'sbp',
                2: 'yookassa',
                3: 'paypal',
                4: 'cloudpayments',
                5: 'mkb',
                6: 'sber',
                7: "prodamus",
            }


            for (let i = 0; i < this.settings.paymentMethodDefault.length; i++) {
                let current = this.settings.paymentMethodDefault[i];
                if (!+this.isHiddenPaymentMethod(pMethods[current])) {
                    this.payment = methods[current];
                    return;
                }
            }
        },
    },

    watch: {
        payment: function(val, oldVal) {
            if (val == 'prodamus') {
                this.$store.commit("data/SET_FOREIGN_PAYMENT", true);
            } else {
                this.$store.commit("data/SET_FOREIGN_PAYMENT", false);
            }
        }
    },

    computed: {
        ...mapState("data", ["data","settings"]),
        showFillFieldsLabelContainer() {
            if (this.fetching) return true;

            if (!this.agreement) return true;
            if (!this.agreementPd) return true;

            return false;
        },
        isLoadingBuyButton() {
            return this.fetching;
        },
        isAgreement() {
            return this.agreement;
        },
        isAgreementPd() {
            return this.agreementPd;
        },
        isAgreementAds() {
            return this.agreementAds;
        },
        isPriceChanged() {
            return this.priceChanged;
        },
        hasNameForComments() {
            return Boolean(+this.$store.state.data.data.has_name_for_comments);
        },
        hasChat() {
            return Boolean(+this.$store.state.data.data.has_chat);
        },
        hasCommentsSelfnaming() {
            return Boolean(+this.$store.state.data.data.comments_selfnaming);
        },
        ...mapState("data", ["settings"]),
        ...mapState("form", ["fetching", "error"]),

        ticketLink: function() {
            return `https://facecast.net/ru/legal/${this.settings && this.settings.agent_is_facecastpro ? 'facecast-pro' : 'facecast'}/ticket/`;
        },

        privacyLink: function() {
            return `https://facecast.net/ru/legal/${this.settings && this.settings.agent_is_facecastpro ? 'facecast-pro' : 'facecast'}/privacy/`;
        },

        privacyPdLink: function() {
            return `https://facecast.net/ru/legal/${this.settings && this.settings.agent_is_facecastpro ? 'facecast-pro' : 'facecast'}/pd-viewer/`;
        },

        adsLink: function() {
            return `https://facecast.net/ru/legal/${this.settings && this.settings.agent_is_facecastpro ? 'facecast-pro' : 'facecast'}/pd-ads-org/`;
        },

        foreignPaymantShow: function () {
            console.log("data", this.data, this.settings)
            return Boolean(this.data.has_foreign_ticket_pay)
        },
    },
};
</script>

<style module>
.collapse {
    margin-bottom: 24px;
}

.collapseTarget {
    height: 36px;
    display: inline-block;
    border: none;
    outline: none;
    cursor: pointer;
    color: rgb(65, 65, 255);
    font-family: inherit;
    font-size: 16px;
    box-sizing: border-box;
    margin-bottom: 12px;
    margin-top: -18px;
    padding: 0;
    border-bottom: 2px dashed currentColor;
    background: transparent;
}

.name > label::after,
.email > label::after,
.phone > label::after {
    content: "*";
    margin-left: 4px;
    color: #ff0000;
}

.name_before_checkbox {
    margin-bottom: 10px !important;
}

.priceChanged {
    font-size: 14px;
    display: block;
    text-align: center;
    margin-top: 12px;
    color: #ff0000;
}

.agreement {
    margin-bottom: 24px;
}

.agreement > label {
    font-size: 16px;
    line-height: 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.agreement > label > input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.agreement > label > div {
    margin: 0 12px 0 0;
    cursor: pointer;
    min-width: 20px;
    min-height: 20px;
    box-shadow: 0 1px 0 0 hsl(225, 5%, 85%), 0 0 0 1px hsl(228, 10%, 90%);
    border-radius: 4px;
    background-color: rgb(238, 238, 238);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.agreement > label > input:focus + div {
    outline-offset: -2px;
    outline: -webkit-focus-ring-color auto 5px;
}

.agreement > label > div > svg {
    width: 16px;
    height: 16px;
    display: block;
    fill: rgb(65, 65, 255);
}

.agreement > label > a {
    color: rgb(65, 65, 255);
    text-decoration: none;
}

.form {
    width: 100%;
    height: 100%;
}

.form__content {
    /* max-width: 600px; */
    width: 100%;
    margin-top: 36px;
    margin-bottom: 48px;
}

.field {
    width: 100%;
}

.field:not(:last-child) {
    margin-bottom: 24px;
}

.field > label {
    font-size: 16px;
    display: block;
}

.field > .phoneInput {
    display: flex;
    margin-top: 12px;
    background-color: #eee;
    border-radius: 4px;
    width: 100%;
    box-sizing: border-box;
    font-family: inherit;
    box-shadow: 0 1px 0 0 hsl(225, 5%, 85%), 0 0 0 1px hsl(228, 10%, 90%);
}

.field > .phoneInput > input {
    display: block;
    font-size: 16px;
    border: none;
    height: 56px;
    background-color: #eee;
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    font-family: inherit;
}

.field > input {
    display: block;
    font-size: 16px;
    border: none;
    height: 56px;
    background-color: #eee;
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    font-family: inherit;
    border-radius: 4px;
    box-shadow: 0 1px 0 0 hsl(225, 5%, 85%), 0 0 0 1px hsl(228, 10%, 90%);
    margin-top: 12px;
}

.select {
    margin-bottom: 24px;
}

.select > h3 {
    font-size: 16px;
    font-weight: 500;
    display: block;
    margin: 0;
    padding: 0;
}

.select > div {
    display: grid;
    grid-gap: 12px;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    box-sizing: border-box;
    margin-top: 12px;
}

.select > div > div {
    border: 2px solid transparent;
}

.select > div > div > label {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    box-shadow: 0 1px 0 0 hsl(225, 5%, 85%), 0 0 0 1px hsl(228, 10%, 90%);
    background-color: #eee;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
    border-radius: 4px;
}

.select > div > div > label.active {
    border: 2px solid #4141ff;
    border-radius: 4px;
}

.select.select_one > div > div > label.active {
    border: none;
}

.select > div > div > label > input {
    display: none;
}

.select > div > div > label > h4 {
    font-size: 16px;
    font-weight: 500;
    display: block;
    margin: 0;
    padding: 0;
    white-space: nowrap;
}

.select .paypalIcons {
    display: flex;
    margin-top: 0;
}

.select .paypalIcons > svg {
    width: 78px;
    height: 28px;
}

.collapse input {
    margin-top: 0;
}

.use_name_in_chat_checkbox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 44px 0 !important;
}

.use_name_in_chat_checkbox > input {
    width: 16px;
    height: 16px;
    padding: 0;
    margin: 0 12px 0 0;
}

.company_creds {
    border-top: 1px solid rgba(0, 0, 0, .1);
    color: rgba(0, 0, 0, .2);
    padding: 5px;
    text-align: center;
    font-size: 13px;
}

.fill_fields_label {
    display: block;
    text-align: center;
    color: #F00;
    margin-top: 24px;
}

.checkbox_error {
    box-shadow: 0px 0px 0px 1px #F00, 0px 0px 0px 4px #FCCFCF !important;
}
</style>
